import React from 'react';
import './ReactionIcon.css';

// Иконка типа реакции по конфигу REACTION_TYPES: emoji-текст, картинка либо
// тонируемый маской силуэт. Переиспользуется гридом панели отправки
// (ReactionsPanel) и тостом-реакцией (ReactionToast)
const ReactionIcon = ({reaction, className = ''}) => {
  if (!reaction) {
    return null;
  }

  // className задает размер иконки (28px по умолчанию, переопределяется
  // вызывающей стороной) — при наличии оверлея он переносится на
  // оборачивающий контейнер, чтобы не задать размер дважды (на обертке и на
  // базовой иконке внутри неё)
  const hasOverlay = Boolean(reaction.overlayMaskSrc);
  const baseIconClassName = hasOverlay ? '' : className;

  let baseIcon;
  if (reaction.emoji) {
    baseIcon = (
      <span className={`reaction-icon reaction-icon_emoji ${baseIconClassName}`} role="img" aria-label={reaction.title}>
        {reaction.emoji}
      </span>
    );
  } else if (reaction.maskSrc) {
    baseIcon = (
      <span
        className={`reaction-icon reaction-icon_masked ${baseIconClassName}`}
        role="img"
        aria-label={reaction.title}
        style={{
          backgroundColor: reaction.maskColor,
          WebkitMaskImage: `url(${reaction.maskSrc})`,
          maskImage: `url(${reaction.maskSrc})`,
        }}
      />
    );
  } else {
    baseIcon = (
      <img
        className={`reaction-icon reaction-icon_img ${baseIconClassName}`}
        src={reaction.iconSrc}
        alt={reaction.title}
      />
    );
  }

  // Иконка-бейдж поверх базовой (например, volume.png на banner.png у
  // реакции "Фракция" — обозначает, что реакция на самом деле проигрывает
  // звук фракции, а не просто показывает баннер)
  if (!hasOverlay) {
    return baseIcon;
  }

  return (
    <span className={`reaction-icon_overlay-wrapper ${className}`}>
      {baseIcon}
      <span
        className={'reaction-icon_overlay reaction-icon_masked'}
        role="img"
        aria-label={reaction.title}
        style={{
          backgroundColor: reaction.overlayMaskColor || 'white',
          WebkitMaskImage: `url(${reaction.overlayMaskSrc})`,
          maskImage: `url(${reaction.overlayMaskSrc})`,
        }}
      />
    </span>
  );
};

export default ReactionIcon;
